import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/app/layout.tsx")